const state = {
  filterTags: [],
  smartSummary: {
    summary: '',
    id_summary: null,
    filter: {
      initialDate: '',
      finalDate: '',
      actions: [],
      sentiments: [],
      csat: []
    },
    is_liked: null
  },
  refusalReasons: [],
  csat: {
    answer_rate: 0,
    score: 0,
    total_answered: 0
  },
  topTerms: [],
  trendsTerms: [],
  feelings: {
    negative: undefined,
    positive: undefined,
    neutral: undefined
  },
  conversationAverages: [],
  isFetchingSmartSummary: false
}

export default state
